export default {
    "10cm": ["스토커", "그라데이션", "폰서트"],
    "경서": ["밤하늘의 별을", "나의 x에게", "넌내꺼야"],
    "성시경": ["너의 모든 순간", "내게 오는 길", "거리에서"],
    "임창정": ["소주한잔", "내가 저지른 사랑", "또 다시 사랑"],
    "폴킴": ["모든 날 모든 순간", "너를 만나", "비"],
    "박효신": ["눈의 꽃", "야생화", "숨"],
    "이수": ["어디에도", "잠시만 안녕", "one love"],
    "케이윌": ["내 생에 아름다운", "가슴이 뛴다", "니가 필요해"],
    "윤종신": ["좋니", "1월부터 6월까지", "오래전 그날"],
    "임영웅": ["사랑은 늘 도망가", "별빛 같은 나의 사랑아", "우리들의 블루스"],
    "윤도현": ["사랑했나봐", "나는 나비", "박하사탕"],
    "허각": ["hello", "흔한 이별", "혼자, 한잔"],
    "장범준": ["흔들리는 꽃들 속에서 네 샴푸 향이 느껴진 거야", "여수밤바다", "노래방에서"],
    "멜로망스": ["사랑인가 봐", "취중고백", "선물"],
    "크러쉬": ["Rush hour", "Beautiful", "가끔"],
    "지코": ["새삥", "아무노래", "Boys and Girls"],
    "아이유": ["내 손을 잡아", "좋은 날", "너랑 나"],
    "김윤아": ["스물다섯, 스물하나", "야상곡", "길"],
    "백지영": ["잊지 말아요", "총 맞은 것처럼", "사랑 안해"],
    "정은지": ["하늘바라기", "나에게로 떠나는 여행", "All for you"],
    "에일리": ["첫눈처럼 너에게 가겠다", "보여줄게", "higher"],
    "송하예": ["니 소식", "이 노래", "새 사랑"],
    "박혜원": ["시든 꽃에 물을 주듯", "차가워진 이 바람엔 우리가 써있어", "친구라도 될 걸 그랬어"],
    "벤": ["열애중", "180도", "꿈처럼"],
    "윤하": ["사건의 지평선", "우산", "비밀번호 486"],
    "백예린": ["Square", "Antifreeze", "Bye Bye My Blue"],
    "헤이즈": ["비도 오고 그래서", "헤픈 우연", "비가 오는 날엔"],
    "태연": ["그대라는 시", "Rain", "11:11"],
    "홍진영": ["사랑의 배터리", "따르릉", "산다는 건"],
    "이선희": ["인연", "그 중에 그대를 만나", "그대 손 놓아요"],
}